export const InvalidId = '00000000';
export const MeshResolution = 120;
export const AlphaSceneVersion = '1.5.0';
export const BetaSceneVersion = '1.5.1';
